<div class="finance-section-container">
    
    <div class="tds-details-section">
        <app-section-header
        [title]="'TDS Details'"
        [subtitle]="'Tax Deducted at Source related declarations and documents.'"
        ></app-section-header>

        <div class="form-container card-layout">

            <app-dynamic-form #tdsForm [readOnly]="viewMode" [formGroup]="getTdsForm()" [formConfig]="tdsFormConfig" (onValueChange)="handleValueChange($event)"></app-dynamic-form>

            <app-file-upload
            [title]="'Click to upload TDS Certificatie or drag and drop'"
            [(files)]="tdsAttachment"
            [allowedFileTypes]="allowedFileTypes"
            [multiFileUpload]="false"
            (filesChange)="onTdsFileChange($event)"
            [disabled]="viewMode"
          ></app-file-upload>

        </div>
    </div>

    <div class="msme-details-section">
        <app-section-header
        [title]="'MSME Information'"
        [subtitle]="'Micro, Small and Medium Enterprises compliance details.'"
        ></app-section-header>

        <div class="form-container card-layout">

            <app-dynamic-form #msmeForm [readOnly]="viewMode" [formGroup]="getMsmeForm()" [formConfig]="msmeFormConfig"></app-dynamic-form>
            
            <app-file-upload *ngIf="getMsmeForm().get('msme')?.value"
            [title]="'Click to upload MSME Certificate or drag and drop'"
            [(files)]="msmeAttachment"
            [allowedFileTypes]="allowedFileTypes"
            [multiFileUpload]="false"
            [disabled]="viewMode"
            (filesChange)="onTdsFileChange($event)"
          ></app-file-upload>

        </div>
    </div>

    <div class="lut-details-section">
        <app-section-header
        [title]="'LUT Details'"
        [subtitle]="'Letter of Undertaking (LUT) information for GST compliance.'"
        ></app-section-header>

        <div class="form-container card-layout">

            <app-dynamic-form #lutForm [readOnly]="viewMode" [formGroup]="getLutForm()" [formConfig]="lutFormConfig"></app-dynamic-form>

            <app-file-upload *ngIf="getLutForm().get('lut')?.value"
            [title]="'Click to upload LUT Certificate'"
            [(files)]="lutAttachment"
            [allowedFileTypes]="allowedFileTypes"
            [multiFileUpload]="false"
            [disabled]="viewMode"
            (filesChange)="onLutFileChange($event)"
          ></app-file-upload>

        </div>
    </div>

</div>